import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface SelectFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function SelectField({ field, value, onChange, readOnly, error }: SelectFieldProps) {
  return (
    <FieldWrapper field={field} error={error}>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={readOnly}
        className="w-full px-2 py-1.5 text-sm border rounded outline-none focus:ring-1 focus:ring-blue-500"
        style={{
          backgroundColor: 'var(--color-bg-input, var(--color-bg-card))',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
        }}
      >
        <option value="">-- Seleziona --</option>
        {field.options?.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </FieldWrapper>
  )
}
